<template>
  <v-app id="app" :style="{'background-color':$vuetify.theme.themes.light.primary +' !important'}">
    <logos
      :src="$headerLogo"
      alt="Idonia"
    ></logos>
    <v-main>
    <register-form></register-form>
    </v-main>
  </v-app>
</template>

<script>
import RegisterForm from '../../components/RegisterForm.vue'
import Logos from '../../components/Logos'
import version from '../../mixins/version'

export default {
  name: 'app',
  mixins: [version],
  components: {
    RegisterForm, Logos
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'Roboto', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

::-webkit-scrollbar-track {
  background: #ddd;
}

::-webkit-scrollbar-thumb {
  background: #666;
}
</style>
